<template>
  <div class="selected-site-container h-100">
    <div class="header-container">
      <div class="close-details clickable" @click="onClose()">
        <div class="x">&times;</div>
      </div>
    </div>
    <field-container title="Selected Site" :parentContainer="true">
      <div class="site-details-container">
        <field-container title="">
          <overview :mappable="selected"></overview>
        </field-container>

        <field-container title="Site Actions">
          <div class="site-actions-text">
            {{ selected.siteActions }}
          </div>
        </field-container>

        <!-- Commented out to be added at a later date -->
        <!-- <field-container title="Create Data Entry">
          <data-entry-section :mappable="selected"></data-entry-section>
        </field-container> -->

        <field-container title="Request Information">
          <div class="request-info-text">
            <div>Contract: {{ contract }}</div>
            <div>Name: {{ name }}</div>
            <div>Address: {{ address }}</div>
            <div>Phone{{ phoneNight ? ' (Day)' : '' }}: {{ phoneDay }}</div>
            <div v-if="phoneNight">Phone (Night): {{ phoneNight }}</div>
            <div>Email{{ phoneNight ? ' 1' : '' }}: {{ email }}</div>
            <div v-if="emailAlt">Email 2: {{ emailAlt }}</div>
            <div>Comments: {{ comments }}</div>
          </div>
        </field-container>
        <div class="requested-on">No Spray requested on {{ requestedOn }}</div>
      </div>
    </field-container>
  </div>
</template>

<script>
import DataEntrySection from './data-entry-section';
import FieldContainer from '../../../common/field-container';
import FieldNotesSection from './field-notes-section.vue';
import Overview from './overview';
import SiteHistorySection from './site-history-section.vue';
import SiteNotesSection from './site-notes-section.vue';
import SiteReminderSection from './site-reminder-section.vue';
import { toTitle } from '@/utils/strings';
import { standardDateStamp } from '@/utils/dates';

export default {
  components: {
    DataEntrySection,
    FieldContainer,
    FieldNotesSection,
    Overview,
    SiteHistorySection,
    SiteNotesSection,
    SiteReminderSection,
  },

  props: {
    selected: Object,
  },

  computed: {
    contract() {
      const { name } = this.selected.contract;
      return name;
    },
    name() {
      const { name, firstName, lastName } = this.selected;
      return toTitle(`${firstName} ${lastName}`);
    },
    address() {
      const { address } = this.selected;
      return toTitle(address);
    },
    phoneDay() {
      const { phone } = this.selected;
      return phone;
    },
    phoneNight() {
      const { altPhone } = this.selected;
      return altPhone;
    },
    email() {
      const { email } = this.selected;
      return email;
    },
    emailAlt() {
      const { email2 } = this.selected;
      return email2;
    },
    comments() {
      const { comments, notes } = this.selected;
      if (notes || notes === '') {
        return notes;
      }

      return comments.map(({ body }) => body).join(', ');
    },
    requestedOn() {
      const { requestType } = this.selected;
      return standardDateStamp(requestType.createdAt);
    },
  },

  methods: {
    onClose() {
      const { dispatch } = this.$store;
      dispatch('selectMappable', null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../../assets/scss/variables';

.flex {
  display: flex;

  & .space-between {
    justify-content: space-between;
  }
}

.selected-site-container {
  margin-top: -1.8rem;
  height: 100%;
}

.site-details-container {
  margin-right: -1rem;
  margin-top: -1rem;
  overflow-x: hidden;
  overflow-y: auto;
  height: 739px;
}

.site-actions-text {
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);
}

.request-info-text {
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  color: rgba(0, 0, 0, 0.87);

  & div {
    margin-bottom: 1.5rem;
  }
}

.requested-on {
  font-family: Roboto;
  font-size: 13px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #757575;
  margin-bottom: 1rem;
}

.header-container {
  display: flex;
  float: right;
  justify-content: space-between;

  & .close-details {
    margin-top: 8px;
    position: relative;
    top: -4px;
    right: 10px;
    width: 11px;
    height: 11px;

    & .x {
      color: #000000;
      font-size: 24px;
      font-weight: 300;
      position: relative;
      bottom: 13px;
      right: 0.5px;
      height: 0;
      width: 0;
    }
  }
}

.clickable {
  cursor: pointer;
}
</style>
